import type { PossibleRewardProps } from './types';

import { ImageUrls } from '../../utils/imageUtils';

export const PRESET_REWARDS: readonly PossibleRewardProps[] = [
  { id: 'breadsticks',      title: 'Breadsticks',           cost: 75,  imageSrc: ImageUrls.sidesBreadsticks3x,    rank: 1 },
  { id: 'cheese-sticks',    title: 'Cheese sticks',         cost: 125, imageSrc: ImageUrls.cheeseSticks180,       rank: 2 },
  { id: 'cinnabon-mini',    title: 'Cinnabon ® Mini Rolls', cost: 150, imageSrc: ImageUrls.cinnabonProduct,       rank: 3 },
  { id: 'wings-8p-boneless',title: '8 piece Boneless wings',cost: 175, imageSrc: ImageUrls.sidesWings3x,          rank: 4 },
  { id: 'medium-2-top',     title: 'Medium 2-top pizza',    cost: 200, imageSrc: ImageUrls.mediumAnyPizzaProduct, rank: 5 },
  { id: 'large-any',        title: 'Large ANY pizza',       cost: 300, imageSrc: ImageUrls.largeAnyPizzaProduct,  rank: 6 },
] as const;

export function getDefaultRewards(): PossibleRewardProps[] {
  // Return a copy so callers don’t accidentally mutate the source.
  return PRESET_REWARDS.map(r => ({ ...r }));
}
